module.exports = "https://web-assets.ifttt.com/packs/media/docs/applet_setup1-b4020f86.png";